import styled from 'styled-components'

export const Container = styled.div`
  flex: 1;
  overflow-y: auto;
  padding: ${props => props.theme.spacing.sp8};
`

export const CategoryHeader = styled.div`
  padding: ${props => props.theme.spacing.sp8} ${props => props.theme.spacing.sp16};
  font-size: 12px;
  font-weight: 600;
  color: ${props => props.theme.colors.text.subtle};
  text-transform: uppercase;
  letter-spacing: 0.5px;
`

export const EmptyState = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: ${props => props.theme.spacing.sp32};
  color: ${props => props.theme.colors.text.subtle};
  font-size: 14px;
`

export const SkeletonContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp8};
  padding: ${props => props.theme.spacing.sp8} ${props => props.theme.spacing.sp16};
`

export const SkeletonRow = styled.div`
  display: flex;
  align-items: center;
  gap: ${props => props.theme.spacing.sp16};
  padding: ${props => props.theme.spacing.sp8} 0;
`
